import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, useState } from 'react';
import { TextAreaWrapper, TextArea as TextArea$2, ValidationText, TextAreaIcon } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ICON_UI_CHECKMARK } from '../../icons/ICON_UI_CHECKMARK.js';
import { ICON_UI_WARNING } from '../../icons/ICON_UI_WARNING.js';

var _excluded = ["disabled", "hasError", "id", "isValid", "maxLength", "name", "onChange", "placeholder", "rows", "showCharacterCount", "validationText", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TextArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'textarea' : _ref$id,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    maxLength = _ref.maxLength,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'textarea' : _ref$name,
    onChange = _ref.onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Enter text here...' : _ref$placeholder,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 3 : _ref$rows,
    _ref$showCharacterCou = _ref.showCharacterCount,
    showCharacterCount = _ref$showCharacterCou === void 0 ? true : _ref$showCharacterCou,
    _ref$validationText = _ref.validationText,
    validationText = _ref$validationText === void 0 ? '' : _ref$validationText,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(value.length),
    _useState2 = _slicedToArray(_useState, 2),
    currentLength = _useState2[0],
    setCurrentLength = _useState2[1];
  var handleChange = function handleChange(e) {
    var newValue = e.target.value;
    setCurrentLength(newValue.length);
    if (onChange) {
      onChange(e);
    }
  };
  var showValidationText = hasError || maxLength && currentLength > maxLength;
  var validationAriaId = id ? "".concat(id, "-validation") : undefined;
  return /*#__PURE__*/jsxs(TextAreaWrapper, {
    children: [/*#__PURE__*/jsx(TextArea$2, _objectSpread(_objectSpread({}, rest), {}, {
      // @ts-ignore
      $hasError: hasError,
      $isValid: isValid,
      "aria-describedby": showValidationText ? validationAriaId : undefined,
      "aria-invalid": hasError || maxLength && currentLength > maxLength,
      "data-cs-mask": true,
      disabled: disabled,
      id: id,
      maxLength: maxLength,
      name: name,
      onChange: handleChange,
      placeholder: placeholder,
      ref: ref,
      rows: rows,
      value: value
    })), showCharacterCount && maxLength && /*#__PURE__*/jsxs(ValidationText, {
      // @ts-ignore
      $hasError: hasError,
      id: validationAriaId,
      children: [currentLength, "/", maxLength, " characters"]
    }), isValid && /*#__PURE__*/jsx(TextAreaIcon, {
      path: ICON_UI_CHECKMARK,
      size: "s"
    }), hasError && /*#__PURE__*/jsx(TextAreaIcon, {
      path: ICON_UI_WARNING,
      size: "s",
      $hasError: true
    }), hasError && validationText && /*#__PURE__*/jsx(ValidationText, {
      // @ts-ignore
      $hasError: hasError,
      id: validationAriaId,
      children: validationText
    })]
  });
});
TextArea.displayName = 'TextArea';
// @ts-expect-error
TextArea.defaultProps = {
  rows: 3,
  placeholder: 'Enter text here...',
  onChange: function onChange() {},
  maxLength: undefined,
  hasError: false,
  validationText: '',
  showCharacterCount: false,
  isValid: false,
  disabled: false
};
var TextArea$1 = TextArea;

export { TextArea$1 as default };
//# sourceMappingURL=TextArea.js.map
